<template>
	<NuxtLayout>
		<NuxtPage />
	</NuxtLayout>
</template>
<script lang="ts" setup>
import useProvideApi from './api/useProvideApi';
import useClientApi from './api/client-only/useClientApi.client';

const baseApiUrl = useBaseApiUrl();
useProvideApi(baseApiUrl);
useClientApi(baseApiUrl);
useNloProvideApi('krasloten');
</script>
